import { useSelector, useDispatch } from "react-redux";
import { useEffect } from "react";

import profileThunk from "../../pages/Profile/redux/thunks";

const useRefreshProfile = () => {
  const user = useSelector((state) => state.profile.user);
  const authUser = useSelector((state) => state.session.authUser);
  const dispatch = useDispatch();
  useEffect(() => {
    if (!user && authUser) {
      dispatch(profileThunk.getProfileAsync(authUser.uid));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!user && authUser) {
      dispatch(profileThunk.getProfileAsync(authUser.uid));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, authUser]);
};

export default useRefreshProfile;
